import * as Helper from "./../../_Helper";
const controller = "/patients/mobile/new?";

function getUrl(uid, qid, regType) {
  return `${controller}uid=${uid}&qid=${qid}&regtype=${regType}`;
}

export function register(http, uid, qid, regType, item) {
  // console.log("register patient ", item, getUrl(uid, qid, regType));
  return http.post(getUrl(uid, qid, regType), item, Helper.getAuthConfig(uid));
}

export function x(http, item) {
  //console.log("register x ");
  const config = {
    headers: {
      "content-type": "application/json",
    },
  };
  return http.post("/patients/mobile/x", item, config);
}
